/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2023.
 */

import { useSettings } from '@/data/Settings';
import { EventsContext } from '@/data/context/events';
import { ProductType } from '@/data/types/Product';
import { useCallback, useContext } from 'react';

type Props = {
	product: ProductType;
	index: number;
	item_list_id: string;
	parentProduct?: ProductType;
	parentPartNumber?: string;
};

export const useCarouselProductEvents = ({
	product,
	index,
	item_list_id,
	parentProduct,
	parentPartNumber,
}: Props) => {
	const { onCarouselProductClick } = useContext(EventsContext);
	const { settings } = useSettings();

	const onClick = useCallback(
		(clickAction?: (() => Promise<void>) | (() => void)) => async () => {
			if (clickAction) {
				await clickAction();
			}
			onCarouselProductClick({
				gtm: {
					product,
					index,
					item_list_id,
					parentProduct,
					parentPartNumber,
					settings,
				},
			});
		},
		[
			onCarouselProductClick,
			product,
			index,
			item_list_id,
			parentProduct,
			parentPartNumber,
			settings,
		]
	);

	return { onClick };
};
